var $ = jQuery.noConflict();

  //menu mobile
var mobileMenu=false;

$( window ).resize(function() {
    if($( window ).width()>991){
        $('.main-menu').css('display','block');
            if(mobileMenu){
            $('.main-menu').removeClass('menuMobile');
                mobileMenu=false;
            }
    }else if(!mobileMenu){
        $('.main-menu').css('display','none');
    }
});

$( ".navbar-toggle" ).click(function() {
    // $( this ).slideUp();
    if(mobileMenu){
        $('.main-menu').slideUp(function() {
        $('.main-menu').removeClass('menuMobile');
    });
        
        mobileMenu=false;
    }else{
        $('.main-menu').addClass('menuMobile');
        $('.main-menu').slideDown();
            mobileMenu=true;
    }
    

});
//menu end 